import { DrawerBody } from "@growtherapy/sprout-ui";
import { AppointmentType } from "../../schedule-preview/types";
import { EditAppointmentFormValues } from "../EditAppointmentDrawer";
import { ScheduleAppointmentFormWrapper as ScheduleAppointmentForm } from "../ScheduleAppointmentForm";
import { GetSchedulingAlertsQueryData } from "../useGetSchedulingAlerts";

interface AddAppointmentDrawerBodyProps {
  formValues: EditAppointmentFormValues;
  onUpdateValues: (values: Partial<EditAppointmentFormValues>) => void;
  appointmentType: AppointmentType;
  timeInputErrorMessage?: string;
  alertsData?: GetSchedulingAlertsQueryData;
}

export function AddAppointmentDrawerBody({
  formValues,
  onUpdateValues,
  appointmentType,
  alertsData,
  timeInputErrorMessage,
}: AddAppointmentDrawerBodyProps) {
  return (
    <DrawerBody>
      <ScheduleAppointmentForm
        formValues={formValues}
        onUpdateValues={onUpdateValues}
        appointmentType={appointmentType}
        alertsData={alertsData}
        timeInputErrorMessage={timeInputErrorMessage}
        isRecurrenceEditable={true}
      />
    </DrawerBody>
  );
}

export function AddAppointmentDrawerBodyWrapper({
  ...props
}: Omit<AddAppointmentDrawerBodyProps, "appointmentType">) {
  return (
    <AddAppointmentDrawerBody
      {...props}
      appointmentType={AppointmentType.FollowUp}
      alertsData={props.alertsData}
    />
  );
}
